import $ from "cash-dom";


if ( window.Pura.header && window.Pura.header.style ){
  $('#mobile-header, #desktop-header').attr('data-header-style', window.Pura.header.style )
}


